// The read-only roles × permissions reference (/api/authz/capabilities).
// Pure documentation served verbatim from shared/access-policy.js — the file
// that also holds the enforced rule, so the table cannot drift away from it.
// Readable by org_admin and platform_admin (whoever assigns roles), enforced
// server-side. Rendered by components/PermissionsMatrix on /organizations.
import { fetchData } from '../fetchapi/fetchapi';

export async function capabilityMatrix() {
  const res = await fetchData('authz/capabilities');
  return { roles: res.roles || [], groups: res.groups || [] };
}
